import React, { useState, useEffect } from "react";
import InfoContainer from "./container/InfoContainer";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import styles from "./EquippedWeapons.module.scss";
import clsx from "clsx";
import notEquippedImg from "../images/inventory_missing.jpg";
import missingPrimaryImg from "../images/equippedweapons/bag_missing-primary.png";
import { useTranslation } from 'react-i18next';
import missingSecondaryImg from "../images/equippedweapons/bag_missing-secondary.png";
import missingMeleeImg from "../images/equippedweapons/bag_missing-melee.png";
import missingGrenadeImg from "../images/equippedweapons/bag_missing-grenade.png";
//https://stackoverflow.com/questions/35250500/correct-way-to-import-lodash
import { range } from "lodash";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import inventoryMissingImg from "../images/inventory_missing.png";


import {
  CDN_URI_BASE,
  handleMissingImg,
} from "../common/utilities";

const slickSliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  // centerMode: true,
  // centerPadding: '12px',
  slidesToShow: 1,
  slidesToScroll: 1,
  dotsClass: clsx('slick-dots', styles.slick_dots_custom)
};

const BagDisplaySettings = {
  bagMaxLength: 7
  ,sackSRLStartOne: 0
  ,sackSRLStartTwo: 10
  ,sackSRLStartThree: 20
};

function WeaponItem(props) {
  const { itemData, cols } = props;
  return (
    <Grid
      item
      container
      xs={cols}
      direction="column"
      justify="center"
      alignItems="center"
      classes={{ root: styles.weapon }}
    >
      <Grid item>
        <img
          src={itemData && itemData.imgURL}
          onError={handleMissingImg(inventoryMissingImg)}
        />
      </Grid>
      <Grid item>
        <span>{itemData && itemData.name}</span>
      </Grid>
    </Grid>
  );
}

function Pagination(props) {
  const { arr, isBagOne, isBagTwo, isBagThree, selectedIndex = 0, onClick } = props;
  const { t } = useTranslation();

  const [selected, setSelected] = useState(selectedIndex);

  const handleClick = e => {
    setSelected(parseInt(e.target.value,10) -1);
    onClick(e.target.value);
  };

  return (
    <>
    <ul className={styles.bag_paginate}>
      <li className={styles.bag_title}>{t('Bag')} 1</li>
      {arr.map((value, index) => {
        return ((value <= (BagDisplaySettings.bagMaxLength)) &&
          <li
            onClick={handleClick}
            key={index}
            value={value}
            className={clsx(selected == value-1 && styles.selected)}
          >
            {parseInt(value,10)}
          </li>
        );
      })}
    </ul>{
      (isBagTwo) &&
      <ul className={styles.bag_paginate}>
      <li className={styles.bag_title}>{t('Bag')} 2</li>
      {arr.map((value, index) => {
        return ((value >= BagDisplaySettings.sackSRLStartTwo && value < (BagDisplaySettings.sackSRLStartTwo + BagDisplaySettings.bagMaxLength)) &&
          <li
            onClick={handleClick}
            key={value}
            value={value}
            className={clsx(selected == value-1 && styles.selected)}
          >
            {parseInt(value,10) - (BagDisplaySettings.sackSRLStartTwo) + 1}
          </li>
        );
      })}
    </ul>
    }
    {
      (isBagThree) &&
      <ul className={styles.bag_paginate}>
      <li className={styles.bag_title}>{t('Bag')} 3</li>
      {arr.map((value, index) => {
        return ((value >=BagDisplaySettings.sackSRLStartThree && value <= (BagDisplaySettings.sackSRLStartThree + BagDisplaySettings.bagMaxLength)) &&
          <li
            onClick={handleClick}
            key={value}
            value={value}
            className={clsx(selected == value-1 && styles.selected)}
          >
            {parseInt(value,10) - (BagDisplaySettings.sackSRLStartThree) + 1}
          </li>
        );
      })}
    </ul>
    }
    </>
  );
}

//returns object where each property is bag number,
//and associated value is an object cotaining info
//about each type of item in bag
function getBagsData(data) {
  if (data == null) {
    return null;
  }

  //console.log('data');
  //window.rawBagData = data;
  //console.log(data);

  const emptyBagData = {
    RIFLE_SLOT: {
      name: "",
      imgURL: missingPrimaryImg
    },
    PISTOL_SLOT: {
      name: "",
      imgURL: missingSecondaryImg
    },
    //only knife slot has default - maybe not - commented out
    // KNIFE_SLOT: {
    //   name: "Knife",
    //   imgURL: `${CDN_URI_BASE}weapon/300_169/C0006.png`
    // },
    KNIFE_SLOT: {
      name: "",
      imgURL: missingMeleeImg
    },
    THROW_SLOT: {
      name: "",
      imgURL: missingGrenadeImg
    }
  };

  // if (data == null) {
  //   return {
  //     1: Object.assign({}, emptyBagData)
  //   };
  // }

  //if we made it here, data is not null, and we continue
  let parsedData = {};
  let my_bag = 1;
  let my_sack_srl = 1;

  //convert api data to object of more readable form
  for (let item of data) {

    my_sack_srl = 1;

    // Players have 2 sets of sacks, 0 - 6, and 10 - 17 (well that's what we knew at the time)

    if(item.SACK_SRL < (BagDisplaySettings.sackSRLStartOne + (BagDisplaySettings.bagMaxLength ))){
      my_sack_srl = item.SACK_SRL + 1; // only because it is zero-indexed
      //console.log(' < 7 -> item.SACK_SRL: ' + item.SACK_SRL + ' my_sack_srl: ' + my_sack_srl);
    }

    if(item.SACK_SRL >= BagDisplaySettings.sackSRLStartTwo && item.SACK_SRL <=(BagDisplaySettings.sackSRLStartTwo + (BagDisplaySettings.bagMaxLength - 1))){
      my_sack_srl = item.SACK_SRL; // - 2;
      //console.log(' 10 <> 17 -> item.SACK_SRL: ' + item.SACK_SRL + ' my_sack_srl: ' + my_sack_srl);
      // continue;
    }

    // 3rd bag added Feb 2024 (it is indexed from 20 - 27 ???)
    if(item.SACK_SRL >= BagDisplaySettings.sackSRLStartThree && item.SACK_SRL <=(BagDisplaySettings.sackSRLStartThree + (BagDisplaySettings.bagMaxLength - 1 ))){
      //console.log(' 20 <> 27 -> item.SACK_SRL: ' + item.SACK_SRL + ' my_sack_srl: ' + my_sack_srl);
      my_sack_srl = item.SACK_SRL; // - 5;
      // continue;
    }


    if (!parsedData.hasOwnProperty(`${my_sack_srl}`)) {
      parsedData[`${my_sack_srl}`] = Object.assign({}, emptyBagData);
    }

    // number the bag it belongs
    if(my_sack_srl <= (BagDisplaySettings.sackSRLStartOne + BagDisplaySettings.bagMaxLength)){
      my_bag = 1; //console.log ('we should see a bag 1');
    }else if(BagDisplaySettings.sackSRLStartTwo <= my_sack_srl &&  my_sack_srl <= (BagDisplaySettings.sackSRLStartTwo + BagDisplaySettings.bagMaxLength)){
      my_bag = 2; //console.log ('we should see a bag 2');
    }else if(BagDisplaySettings.sackSRLStartThree <= my_sack_srl &&  my_sack_srl <= (BagDisplaySettings.sackSRLStartThree + BagDisplaySettings.bagMaxLength)){
      my_bag = 3; //console.log ('we should see a bag 3');
    }else{
      my_bag = 'N/A, maybe 4';
    }

    parsedData[`${my_sack_srl}`][item.WEAPON_TYPE] = {
      name: item.DISPLAY_NAME,
      bag: my_bag, // not actually used
      SACK_SRL: item.SACK_SRL,
      MY_SACK_SRL: my_sack_srl,
      imgURL: `${CDN_URI_BASE}web/inventory/weapons/300_169/${item.ITEM_CODE}.png`
    };
  }

  //console.log('bags');
  //console.log(parsedData);
  //window.bagsData = parsedData;
  return parsedData;
}

  // Proper numeric sort, because javascript (most times) has "no idea" what a number is
  // plain javascript sort	: ["0", "1", "10", "2", "3", "4", "5", "6", "7", "8", "9"]
  // with sortNumber			: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]
  function sortNumber(a, b) {
    return a - b;
  }

export default function EquippedWeapons(props) {
  const { height, data } = props;
  const { t } = useTranslation();

  const bagsData = getBagsData(data);

  //console.log(bagsData);

  const [isBagOne, setisBagOne] = useState(false);
  const [isBagTwo, setisBagTwo] = useState(false);
  const [isBagThree, setisBagThree] = useState(false);

  const orderedBagNumbers =
    bagsData != null ? Object.keys(bagsData).sort(sortNumber) : [];

  //window.orderedBagNumbers = orderedBagNumbers;

  const [selected, setSelected] =
    useState(orderedBagNumbers.length > 0 ? orderedBagNumbers[0] : null);

  useEffect(() => {
    setSelected(
      orderedBagNumbers.length > 0 ? orderedBagNumbers[0] : null
    );

    // set the bag numbers (again)
    for(let i=0;i<orderedBagNumbers.length;i++){

      let x = parseInt(orderedBagNumbers[i]);

      //console.log('orderedBagNumbers number: ' + x);

      if(x <= (BagDisplaySettings.sackSRLStartOne + BagDisplaySettings.bagMaxLength)){setisBagOne(true);}

      if(x >= BagDisplaySettings.sackSRLStartTwo && x < (BagDisplaySettings.sackSRLStartTwo + BagDisplaySettings.bagMaxLength)){setisBagTwo(true);}

      if(x >= BagDisplaySettings.sackSRLStartThree && x < (BagDisplaySettings.sackSRLStartThree + BagDisplaySettings.bagMaxLength)){setisBagThree(true);}
    }


  }, [data]);

  const changeBag = bagNumber => {
    setSelected(bagNumber);
  };

  const selectedBagData = selected != null ?
    bagsData[selected] :
    null;

  const sliderContent = selectedBagData == null ? null : (
    orderedBagNumbers.map(bagNo => (
      <div key={bagNo}>
        <Grid container item spacing={2} classes={{ root: styles.slider_item }}>
          <WeaponItem itemData={bagsData[bagNo].RIFLE_SLOT} cols={12} />
          <WeaponItem itemData={bagsData[bagNo].PISTOL_SLOT} cols={12} />
          <WeaponItem itemData={bagsData[bagNo].KNIFE_SLOT} cols={12} />
          <WeaponItem itemData={bagsData[bagNo].THROW_SLOT} cols={12} />
        </Grid>
      </div>))
    );


  let content = selectedBagData == null ? null : (
    <>
      {/* shown only on desktop */}
      <Hidden xsDown>
        <InfoContainer
          headerLeft={t('Equipped Weapons')}
          // bag number start from zero, so add 1 to each
          headerRight={
            <Pagination arr={orderedBagNumbers} isBagOne={isBagOne} isBagTwo={isBagTwo} isBagThree={isBagThree} onClick={changeBag} />
          }
          height={height}
        >
          <Hidden smDown>
            <Grid container item spacing={2}>
              <WeaponItem itemData={selectedBagData.RIFLE_SLOT} cols={3} />
              <WeaponItem itemData={selectedBagData.PISTOL_SLOT} cols={3} />
              <WeaponItem itemData={selectedBagData.KNIFE_SLOT} cols={3} />
              <WeaponItem itemData={selectedBagData.THROW_SLOT} cols={3} />
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid container item spacing={2}>
              <WeaponItem itemData={selectedBagData.RIFLE_SLOT} cols={6} />
              <WeaponItem itemData={selectedBagData.PISTOL_SLOT} cols={6} />
            </Grid>
            <Grid container item spacing={2}>
              <WeaponItem itemData={selectedBagData.KNIFE_SLOT} cols={6} />
              <WeaponItem itemData={selectedBagData.THROW_SLOT} cols={6} />
            </Grid>
          </Hidden>
        </InfoContainer>
      </Hidden>
      {/* shown only on mobile */}
      <Hidden smUp>
        <InfoContainer
          headerLeft="Equipped Weapons"
          // bag number start from zero, so add 1 to each
          // footer={<Pagination arr={orderedBagNumbers} onClick={changeBag} />}
          height={height}
        >
          <Slider {...slickSliderSettings}>
            {sliderContent}
          </Slider>
        </InfoContainer>
      </Hidden>
    </>
  );


  return content;
}
